import { usePageTitle } from '@shared/hooks/usePageTitle';
import { LiveWebsockets } from '@features/admin/live-websockets/LiveWebsockets';
export const LiveWebsocketsPage = () => {
  usePageTitle('Live Websockets');

  return <LiveWebsockets />;
};
